export var MessageOrientation;
(function (MessageOrientation) {
    MessageOrientation["Portrait"] = "portrait";
    MessageOrientation["Landscape"] = "landscape";
})(MessageOrientation || (MessageOrientation = {}));
export var KeyboardsAllowedMediaProviders;
(function (KeyboardsAllowedMediaProviders) {
    KeyboardsAllowedMediaProviders["Giphy"] = "Giphy";
})(KeyboardsAllowedMediaProviders || (KeyboardsAllowedMediaProviders = {}));
//# sourceMappingURL=InputKeyboards.js.map